import React from 'react';
import { Space, Table, TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import { Message, Pagination } from '../../../../types/messageTypes';
import { formatDateTime } from '../../../../utils/dateUtils';
import NoDataComponent from '../../../../components/Common/NoData';
import UserProfileHeader from 'components/Common/ui/UserProfileHeader';
import CustomButton from 'components/Common/ui/CustomButton';

interface MessagesTableProps {
  messages: Message[];
  pagination: Pagination;
  onPageChange: (page: number, pageSize: number) => void;
  onMessageSelect: (message: Message) => void;
}

const MessagesTable: React.FC<MessagesTableProps> = ({
  messages,
  pagination,
  onPageChange,
  onMessageSelect,
}) => {
  const { t } = useTranslation(); // Translation hook

  const columns: TableColumnsType<Message> = [
    {
      title: t('sender'), // Translated title
      dataIndex: ['sender', 'name'],
      key: 'sender',
      width: '20%',
      align: 'center',
      ellipsis: true,
      render: (text: string, record: Message) => (
        <UserProfileHeader
          photo={record.sender?.photo}
          firstName={record.sender?.firstName || ""}
          lastName={record.sender?.lastName || ""}
        />
      ),
    },
    {
      title: t('message_subject'),
      dataIndex: 'subject',
      key: 'subject',
      width: '50%',
      align: 'center',
      ellipsis: true,
    },
    {
      title: t('date'),
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: '20%',
      align: 'center',
      ellipsis: true,
      render: (timestamp: string) => formatDateTime(timestamp),
    },
    {
      title: t('actions'),
      key: 'actions',
      width: '10%',
      align: 'center',
      render: (_: any, record: Message) => (
        <Space>
          <CustomButton
            onClick={() => onMessageSelect(record)}
            variant="outline-primary"
          >
            <i className="ti ti-eye me-2" />
            {t("show")}
          </CustomButton>
        </Space>
      ),
    },
  ];

  const onRow = (record: Message) => ({
    onClick: () => onMessageSelect(record),
  });

  return (
    <div className="table-responsive">
      <Table
        columns={columns}
        dataSource={messages}
        rowKey="messageId"
        // onRow={onRow}
        locale={{ emptyText: <NoDataComponent/>}}
        pagination={{
          current: pagination.page,
          pageSize: pagination.limit,
          total: pagination.total,
          onChange: onPageChange,
        }}
      />
    </div>
  );
};

export default MessagesTable;
